import classNames from 'classnames';
import styles from './PostTopicItem.module.scss';

type PostTopicItemProps = {
  text: string;
  fontSize?: number;
  isActive: boolean;
  color?: string;
  background?: string;
};

const PostTopicItem = ({
  text,
  isActive,
  fontSize = 8,
  color = '#CCCCCC',
  background = '#EEEEEE',
}: PostTopicItemProps) => {
  return (
    <span
      className={classNames(styles.postTopicItem, {
        [styles.active]: isActive,
      })}
      style={{
        fontSize: `${fontSize}px`,
        color: color,
        background: background,
      }}
    >
      {text}
    </span>
  );
};

export default PostTopicItem;
